import * as React from 'react';
import { connect } from 'react-redux';
import { Image } from 'react-bootstrap';
import { showUpdateCustomerInfo } from '../../actions/modalActions';
import { updateCustomerInfo, infoUpdated, hideMobileProfile, copyToEdit, dataUpdated, setPolicyReducer } from '../../actions/profileActions';
import './PersonalDetails.css';
import { FIELD_EMAIL, FIELD_PHONENUMBER, FIELD_ALTPHONENUMBER, SET_CUSTOMER_DATA } from '../../constants/constants';
import ProfileNavDesktop from '../ProfileNavigation/ProfileNavDesktop';
import { validateEmail } from './../../constants/validation';
import { postToController } from '../../actions/apiActions';

class PersonalDeets extends React.PureComponent<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            isInEdit: this.props.profile.isEditMode,
            editPhone: this.props.profile.cellphoneNumber,
            editAlternateNumber: this.props.profile.alternateNumber,
            editEmail: this.props.profile.email,
            editPhoneHadValue: false,
            editAlternateNumberHadValue: false,
            editEmailHadValue: false,
            languageList: [],
            preferredLanguageDropdownOpen: false,
            mailRegex: false,
            updatedField: "",
        };

        this.handleChange = this.handleChange.bind(this);
        this.showFieldUpdate = this.showFieldUpdate.bind(this);
        this.editInfo = this.editInfo.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.resetData = this.resetData.bind(this);
        this.saveEdit = this.saveEdit.bind(this);
        this.getLanguages = this.getLanguages.bind(this);
    }

    async componentDidMount() {
        await this.props.dispatch(copyToEdit())
        this.props.dispatch(hideMobileProfile());
        if (this.state.languageList.length === 0) {
            this.getLanguages();
        }
    }

    async componentDidUpdate() {
        if (this.props.profile.updateEditData) {
            switch (this.state.updatedField) {
                case FIELD_EMAIL:
                    this.setState({
                        editEmail: this.props.profile.editEmail,
                        updatedField: ""
                    });
                    break;
                case FIELD_PHONENUMBER:
                    this.setState({
                        editPhone: this.props.profile.editCellphoneNumber,
                        updatedField: ""
                    });
                    break;
                case FIELD_ALTPHONENUMBER:
                    this.setState({
                        editAlternateNumber: this.props.profile.editAlternateNumber,
                        updatedField: ""
                    });
                    break;
                default:
            }
            await this.props.dispatch(dataUpdated())
        }
    }

    async getLanguages() {
        await postToController(this.props.dispatch, 'GetLanguages', JSON.stringify({ Parameter: 244 })).then(async (response) => {
            await this.setState({ languageList: response });
            return true;
        })
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    async showFieldUpdate(e: any) {
        let value = e.target.id;
        await this.setState({ updatedField: value, isInEdit: true });
        this.props.dispatch(showUpdateCustomerInfo(value));
    }

    async editInfo() {
        await this.props.dispatch(copyToEdit())
        await this.setState({
            editPhone: this.props.profile.cellphoneNumber,
            editAlternateNumber: this.props.profile.alternateNumber,
            editEmail: this.props.profile.email,
            editPhoneHadValue: false,
            editAlternateNumberHadValue: false,
            editEmailHadValue: false,
        });
        if (this.state.editPhone) {
            await this.setState({ editPhoneHadValue: true })
        }
        if (this.state.editAlternateNumber) {
            await this.setState({ editAlternateNumberHadValue: true })
        }
        if (this.state.editEmail) {
            await this.setState({ editEmailHadValue: true })
        }
        await this.setState({ isInEdit: true });
    }

    cancelEdit(e: any) {
        this.resetData();
        this.setState({
            isInEdit: false,
            editPhone: this.props.profile.cellphoneNumber,
            editAlternateNumber: this.props.profile.alternateNumber,
            editEmail: this.props.profile.email,
            editPhoneHadValue: false,
            editAlternateNumberHadValue: false,
            editEmailHadValue: false,
        });
        this.props.dispatch(setPolicyReducer(SET_CUSTOMER_DATA, "isEditMode", false));
    }

    async resetData() {
        await this.props.dispatch(copyToEdit())
        await this.setState({
            editPhone: this.props.profile.cellphoneNumber,
            editAlternateNumber: this.props.profile.alternateNumber,
            editEmail: this.props.profile.email,
            editPhoneHadValue: false,
            editAlternateNumberHadValue: false,
            editEmailHadValue: false,
        });
        if (this.state.editPhone) {
            await this.setState({ editPhoneHadValue: true })
        }
        if (this.state.editAlternateNumber) {
            await this.setState({ editAlternateNumberHadValue: true })
        }
        if (this.state.editEmail) {
            await this.setState({ editEmailHadValue: true })
        }
        this.props.dispatch(infoUpdated())
    }

    async saveEdit() {
        if (this.state.editEmail) {
            if (validateEmail.test(this.state.editEmail)) {
                this.setState({ mailRegex: false });
                this.props.dispatch(updateCustomerInfo(this.state))
                this.setState({
                    isInEdit: false,
                    editPhoneHadValue: false,
                    editAlternateNumberHadValue: false,
                    editEmailHadValue: false,
                });
            } else {
                this.setState({ mailRegex: true });
            }
        }
        else {
            this.setState({ mailRegex: false });
            this.props.dispatch(updateCustomerInfo(this.state))
            this.setState({
                isInEdit: false,
                editPhoneHadValue: false,
                editAlternateNumberHadValue: false,
                editEmailHadValue: false,
            });
        }
        this.props.dispatch(setPolicyReducer(SET_CUSTOMER_DATA, "isEditMode", false));
    }

    public render() {
        const { profile, lifePolicy } = this.props;

        return (
                <div id="PersonalDetailCard">
                    <div className="col-12 px-0 pb-lg-3">
                        <div className="p-2 text-lg-right invisible">
                            <p className="Last-updated">Last updated: <span>-- -- -- --</span></p>
                        </div>
                        <div className="container-fluid">
                            <div className="text-center">
                                <ProfileNavDesktop />
                                {!this.state.isInEdit &&
                                    <div className="col-12 mt-3 mb-3">
                                        <button className="btn btn-outline-red" onClick={this.editInfo} id='EditPersonalInfo'>Edit details</button>
                                    </div>
                                }
                                {this.state.isInEdit &&
                                    <div className="">
                                        <div className="col-12 mt-3 mb-3">
                                            <button className="btn btn-outline-red mr-lg-3 mb-2 ml-2" onClick={this.cancelEdit} id='CancelPersonalEdit'>Cancel edit</button>
                                            <button className="btn btn-outline-red mt-lg-0 mb-2 ml-2" onClick={this.saveEdit} id='SavePersonalEdit'>Save changes</button>
                                        </div>
                                    </div>
                                }
                            </div>
                            <hr />
                            <div className="">
                                <h3 className="Personal-information">Personal details</h3>
                            </div>

                            {profile.title &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Title</p>
                                        <p id="personalInfoTitle" className="col-lg-6 col-12 Personaldeets text-lg-right">{profile.title}</p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.name &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Name</p>
                                        <p id="personalInfoName" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.name}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.surname &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Surname</p>
                                        <p id="personalInfoSurname" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.surname}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.dateOfBirth &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Date of birth</p>
                                        <p id="personalInfoDOB" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.dateOfBirth}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.idNumber &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">ID no.</p>
                                        <p id="personalInfoIdNumber" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.idNumber}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.selectedPersonalPolicy !== undefined &&
                                <>
                                    {profile.selectedPersonalPolicy.length > 0 && profile.selectedPersonalPolicy.policyNumber &&
                                        <div className="">
                                            <div className="row">
                                                <p className="col-6"><b>Policy no.</b></p>)
                                                <p className="col-6"><b>{profile.selectedPersonalPolicy.policyNumber}</b></p>
                                            </div>
                                            <hr className="d-block d-lg-none d-md-none" />
                                        </div>
                                    }
                                </>
                            }
                            {this.props.ssp?.livinEnabled && lifePolicy?.policy?.id &&
                                <>
                                    {lifePolicy?.policy?.name &&
                                        <div className="">
                                            <div className="row">
                                                <p className="col-6"><b>Livin' policy no.</b></p>
                                                <p className="col-6"><b>{lifePolicy.policy.name}</b></p>
                                            </div>
                                            <hr className="d-block d-lg-none d-md-none" />
                                        </div>
                                    }
                                </>
                            }
                            {(profile.editCellphoneNumber) &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Phone no.</p>
                                        {!this.state.isInEdit &&
                                            <p id="personalInfoCellphone" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.editCellphoneNumber}<Image src='./Images/Claims/Edit-pen-grey.svg' className="img-fluid ml-2 btn-edit" onClick={this.editInfo} /> </b></p>
                                        }
                                        {this.state.isInEdit &&
                                            <div className="container col-lg-6 col-12 mb-2 ">
                                                <input type='text' className="form-control text-lg-right" value={this.state.editPhone} name="editPhone" onChange={this.handleChange}></input>
                                            </div>
                                        }
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {(profile.editAlternateNumber) &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Alternative contact number</p>
                                        {!this.state.isInEdit &&
                                            <p id="personalInfoAlternative" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.editAlternateNumber} <Image src='./Images/Claims/Edit-pen-grey.svg' className="img-fluid ml-2 btn-edit" onClick={this.editInfo} /></b></p>
                                        }
                                        {this.state.isInEdit &&
                                            <div className="container col-lg-6 col-12 mb-2 ">
                                                <input type='text' className="form-control text-lg-right" value={this.state.editAlternateNumber} name="editAlternateNumber" onChange={this.handleChange} ></input>
                                            </div>
                                        }
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {(profile.editEmail) &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Email</p>
                                        {!this.state.isInEdit &&
                                            <p id="personalInfoEmail" className="col-lg-6 col-12 Personaldeets text-lg-right" style={{ overflowWrap: "break-word" }}><b>{profile.editEmail}<Image src='./Images/Claims/Edit-pen-grey.svg' className="img-fluid ml-2 btn-edit" onClick={this.editInfo} /> </b></p>
                                        }
                                        {this.state.isInEdit &&
                                            <div className="col-lg-6 col-12 mb-2 container">
                                                <input type='text' className="form-control text-lg-right" value={this.state.editEmail} name="editEmail" onChange={this.handleChange}></input>
                                            </div>
                                        }
                                        {this.state.isInEdit && this.state.mailRegex &&
                                            <div className="help-block mt-2 float-right">A valid email is required</div>
                                        }
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.homeAddress &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Home address</p>
                                        <p id="personalInfoHomeAddress" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.homeAddress}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.workAddress &&
                                <div className="">
                                    <div className="row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Work address</p>
                                        <p id="personalInfoWorkAddress" className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.workAddress}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.occupation &&
                                <div className="">
                                    <div className="col-12 row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Occupation</p>
                                        <p className="col-lg-6 col-12 pl-0 Personaldeets text-lg-right"><b>{profile.occupation}</b></p>
                                    </div>
                                    <hr className="d-block d-lg-none d-md-none" />
                                </div>
                            }
                            {profile.maritalStatus &&
                                <div className="">
                                    <div className="col-12 row">
                                        <p className="col-lg-6 col-12 mb-1 PersonalLabels">Marital status:</p>
                                        <p className="col-lg-6 col-12 Personaldeets text-lg-right"><b>{profile.maritalStatus}</b></p>
                                    </div>
                                </div>
                            }
                            <div className="row personalInfoTitle">
                                {!this.props.profile.editEmail && !this.state.editEmailHadValue &&
                                    <div className="col-12 mt-3 mb-3">
                                        <div className="row">
                                            <p className="col-8 mb-1 PersonalLabels">Add an email</p>
                                            <div className="col-4 PersonalLabels text-lg-right btn-edit text-right" onClick={this.showFieldUpdate} id={FIELD_EMAIL}><Image src='./Images/PersonalDetails/icon-plus-dark-green.svg' id={FIELD_EMAIL} className="img-fluid mr-2 btn-edit" />Add</div>
                                        </div>
                                    </div>
                                }
                                {!this.props.profile.editCellphoneNumber && !this.state.editPhoneHadValue &&
                                    <div className="col-12 mt-3 mb-3">
                                        <div className="row">
                                            <p className="col-8 mb-1 PersonalLabels">Add a phone no.</p>
                                            <div className="col-4 PersonalLabels text-lg-right btn-edit text-right" onClick={this.showFieldUpdate} id={FIELD_PHONENUMBER}><Image src='./Images/PersonalDetails/icon-plus-dark-green.svg' id={FIELD_PHONENUMBER} className="img-fluid mr-2 btn-edit" />Add</div>
                                        </div>
                                    </div>
                                }
                                {!this.props.profile.editAlternateNumber && !this.state.editAlternateNumberHadValue &&
                                    <div className="col-12 mt-3 mb-3">
                                        <div className="row">
                                            <p className="col-8 mb-1 PersonalLabels">Alternative contact no.</p>
                                            <div className="col-4 PersonalLabels text-lg-right btn-edit text-right" onClick={this.showFieldUpdate} id={FIELD_ALTPHONENUMBER}><Image src='./Images/PersonalDetails/icon-plus-dark-green.svg' id={FIELD_ALTPHONENUMBER} className="img-fluid mr-2 btn-edit" />Add</div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        lifePolicy: state.lifePolicy
    }
}

export default connect(mapStateToProps)(PersonalDeets);